import { render, staticRenderFns } from "./BillCorrection.vue?vue&type=template&id=33042c82&scoped=true"
import script from "./BillCorrection.vue?vue&type=script&lang=js"
export * from "./BillCorrection.vue?vue&type=script&lang=js"
import style0 from "./BillCorrection.vue?vue&type=style&index=0&id=33042c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33042c82",
  null
  
)

export default component.exports